import { axios, base } from '../http';

// ==================== 1. 失物招领管理员 ====================

/**
 * 分页获取失物招领管理员列表
 * @param {Object} params { page, intPageSize, schoolId, campusId, name }
 */
export const getLostAndFoundAdminListPage = (params) => {
  return axios.get(`${base}/api/LostAndFoundAdmin/GetList`, { params });
};

/**
 * 获取可添加为失物招领管理员的教职工候选列表
 * @param {Object} params { schoolId, campusId, keyword }
 */
export const getLostAndFoundCandidateTeachers = (params) => {
  return axios.get(`${base}/api/LostAndFoundAdmin/GetCandidateTeachers`, { params });
};

/**
 * 新增失物招领管理员
 * @param {Object} data { schoolId, campusId, teacherId, name, remark }
 */
export const addLostAndFoundAdmin = (data) => {
  return axios.post(`${base}/api/LostAndFoundAdmin/Add`, data);
};

/**
 * 更新失物招领管理员（备注/启用）
 * @param {Object} data { id, remark, enabled }
 */
export const updateLostAndFoundAdmin = (data) => {
  return axios.post(`${base}/api/LostAndFoundAdmin/Update`, data);
};

/**
 * 快捷启停用失物招领管理员
 * @param {Object} params { id, enabled }
 */
export const toggleLostAndFoundAdminEnable = (params) => {
  return axios.post(`${base}/api/LostAndFoundAdmin/ToggleEnable`, null, { params });
};

/**
 * 移除失物招领管理员
 * @param {Object} params { id }
 */
export const deleteLostAndFoundAdmin = (params) => {
  return axios.post(`${base}/api/LostAndFoundAdmin/Delete`, null, { params });
};

// ==================== 2. 失物招领参数配置 ====================

/**
 * 获取学校失物招领参数配置
 * @param {Object} params { schoolId }
 */
export const getLostAndFoundConfig = (params) => {
  return axios.get(`${base}/api/LostAndFoundConfig/GetConfig`, { params });
};

/**
 * 获取表扬点评项树（Praise）
 * @param {Object} params { schoolId }
 */
export const getLostAndFoundPraiseItemTree = (params) => {
  return axios.get(`${base}/api/LostAndFoundConfig/GetPraiseItemTree`, { params });
};

/**
 * 保存学校失物招领参数配置
 * @param {Object} data { schoolId, displayDays, cplateMaxCount, dailyEvalLimit, evaluationEnabled, evaluationItemId, evaluationScore }
 */
export const saveLostAndFoundConfig = (data) => {
  return axios.post(`${base}/api/LostAndFoundConfig/SaveConfig`, data);
};

// ==================== 3. 失物记录 ====================

/**
 * 分页获取失物记录列表
 * @param {Object} params { page, intPageSize, schoolId, keyword, status, onlyExpired, campusId, classId, classIds, startTime, endTime, ... }
 */
export const getLostAndFoundListPage = (params) => {
  return axios.get(`${base}/api/LostAndFound/GetList`, { params });
};

/**
 * 获取失物记录详情
 * @param {Object} params { id }
 */
export const getLostAndFoundDetail = (params) => {
  return axios.get(`${base}/api/LostAndFound/GetDetail`, { params });
};

/**
 * 修改失物名称、备注与照片
 * @param {Object} data { id, itemName, remark, photoUrls }
 */
export const updateLostAndFound = (data) => {
  return axios.post(`${base}/api/LostAndFound/Update`, data);
};

/**
 * 撤销核销（恢复为公示中）
 * @param {Object} data { id }
 */
export const cancelLostAndFoundClaim = (data) => {
  return axios.post(`${base}/api/LostAndFound/CancelClaim`, data);
};

/**
 * 作废失物记录
 * @param {Object} data { id, reason, operatorId, operatorName }
 */
export const voidLostAndFound = (data) => {
  return axios.post(`${base}/api/LostAndFound/Void`, data);
};

/**
 * 补发失败点评（幂等）
 * @param {Object} params { id }
 */
export const retryLostAndFoundEvaluation = (params) => {
  return axios.post(`${base}/api/LostAndFound/RetryEvaluation`, null, { params });
};

/**
 * 导出失物记录 Excel
 * @param {Object} params 与列表查询条件一致
 */
export const exportLostAndFound = (params) => {
  return axios.get(`${base}/api/LostAndFound/Export`, { params, responseType: 'blob' });
};

// ==================== 4. 失物统计 ====================

/**
 * 获取失物统计汇总
 * @param {Object} params { schoolId, periodType, campusId, classId, semesterId, weekNo, yearMonth, startTime, endTime }
 */
export const getLostAndFoundStats = (params) => {
  return axios.get(`${base}/api/LostAndFound/GetStats`, { params });
};

/**
 * 获取班级捡拾统计
 * @param {Object} params 同 GetStats
 */
export const getLostAndFoundClassStats = (params) => {
  return axios.get(`${base}/api/LostAndFound/GetClassStats`, { params });
};

/**
 * 获取学生捡拾明细统计
 * @param {Object} params 同 GetStats，可带 classId 下钻
 */
export const getLostAndFoundStudentStats = (params) => {
  return axios.get(`${base}/api/LostAndFound/GetStudentStats`, { params });
};

/**
 * 导出失物统计 Excel
 * @param {Object} params 同 GetStats
 */
export const exportLostAndFoundStats = (params) => {
  return axios.get(`${base}/api/LostAndFound/ExportStats`, { params, responseType: 'blob' });
};
